import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './WorkOrders.frontend.types'

@Injectable({ providedIn: 'root' })
export class WorkOrders_is_workorder_deletable_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { workOrderId: number }): Promise<{ reason?: string }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.workOrderId)) {
      $missingRequiredInParams.push('\'workOrderId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

